"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormControl.default;
  }
});
Object.defineProperty(exports, "useFormControl", {
  enumerable: true,
  get: function get() {
    return _useFormControl.default;
  }
});

var _FormControl = _interopRequireDefault(require("./FormControl"));

var _useFormControl = _interopRequireDefault(require("./useFormControl"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/FormControl/index.js
// module id = 68
// module chunks = 0